import { render, staticRenderFns } from "./MyPostForm.vue?vue&type=template&id=3c020b31&"
import script from "./MyPostForm.vue?vue&type=script&lang=js&"
export * from "./MyPostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports